import React, { useMemo } from "react";
import { FiltersTypes } from "@common/types/filters/general";
import { useCurrentWorkspaceMembers } from "@api/workspaceMember.api";
import { formatFilterLabel } from "./formatFilterLabel";

interface Props {
    filters: FiltersTypes;
}

export const TaskCreatedByFilterLabel: React.FC<Props> = ({ filters }) => {
    const { data: workspaceMembers } = useCurrentWorkspaceMembers();
    const { taskCreatedByIds, isTaskCreatedByClient } = filters;

    const labels = useMemo(() => {
        const memberLabels =
            workspaceMembers
                ?.filter((member) => taskCreatedByIds?.includes(member.user.id))
                .map((member) => member.user.name) ?? [];
        return isTaskCreatedByClient
            ? ["Client", ...memberLabels]
            : memberLabels;
    }, [workspaceMembers, taskCreatedByIds, isTaskCreatedByClient]);

    if (!isTaskCreatedByClient && !taskCreatedByIds?.length) {
        return null;
    }

    return formatFilterLabel(labels);
};
